import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Ng2-select
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';

import { SiteRoutingModule } from './site-routing.module';
import { SiteSummaryComponent, SiteSummaryService } from './site-summary';
import { SiteCreateComponent, SiteCreateService } from './site-create';
import { SiteEditComponent, SiteEditService } from './site-edit';
import { SiteDetailComponent, SiteDetailService, SiteUpdateStatusService } from './site-detail';

import { DisplayIdModule } from '../../../directives';
import { SiteRecordSheetComponent } from './site-record-sheet/site-record-sheet.component';
import { SiteEquipmentLayoutPlanComponent } from './site-equipment-layout-plan/site-equipment-layout-plan.component';
import { SiteEquipmentLayoutPlanService } from './site-equipment-layout-plan/site-equipment-layout-plan.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    ReactiveFormsModule,
    SharedModule,
    SiteRoutingModule,
    DisplayIdModule,
    SelectModule,
    AngularMultiSelectModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    SiteSummaryComponent,
    SiteDetailComponent,
    SiteCreateComponent,
    SiteEditComponent,
    SiteRecordSheetComponent,
    SiteEquipmentLayoutPlanComponent
  ],
  providers: [
    SiteCreateService,
    SiteEditService,
    SiteSummaryService,
    SiteDetailService,
    SiteUpdateStatusService,
    SiteEquipmentLayoutPlanService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
],
})
export class SiteModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site.module.ts